// extracted by mini-css-extract-plugin
module.exports = {"padding":"CreateInvoice_padding__H2wOR"};